import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";

import { RECAPTCHA_VERSION } from "../../../packs/grecaptcha";
import { errorsMessageUploaderImageSingle, filterValues } from "../utils";

export const Cover = ({
  project,
  label,
  maxUploadSizeMessage,
  descriptionMessage,
  progressMessage,
  maxNumFiles,
  minWidth,
  minHeight,
  isMobile,
  validateForm,
  onRemove,
  onCoverStartLoading,
  onCoverStopLoading,
  onSaveProject,
  onFocusElement,
  afterRemoveElement,
  reCaptchaVersion,
  ...rest
}) => {
  const onCoverLoad = async image => {
    onCoverStartLoading();
    onFocusElement();

    const correctCover = filterValues(image, "error");

    if (correctCover?.length <= 0 || !correctCover[0]) {
      onCoverStopLoading();
      return;
    }

    const { base64: coverImage, name: coverFileName } = correctCover[0];
    const newProject = { ...project, cover: coverImage, coverFileName };

    await onSaveProject(newProject, false, reCaptchaVersion);

    onCoverStopLoading();
  };

  return (
    <Form.Field size="small" label={label} required id="cover" {...rest}>
      {project.cover ? (
        <Form.RemoveItemWrapper
          id="coverUploadedRemove"
          action={() => {
            onRemove({ cover: null });
            afterRemoveElement();
          }}
          isMobile={isMobile}
        >
          <Form.ContentImage
            id="coverUploaded"
            src={project.cover}
            noCaption
            aspectRatio={1 / 1}
            {...{ "data-label": "project-cover-image" }}
          />
        </Form.RemoveItemWrapper>
      ) : (
        <Form.Uploader
          maxUploadSizeMessage={maxUploadSizeMessage}
          descriptionMessage={descriptionMessage}
          progressMessage={progressMessage}
          progressNumber={70}
          id="cover"
          key="cover"
          onImagesLoad={onCoverLoad}
          name="cover"
          size="small"
          maxNumFiles={maxNumFiles}
          validate={validateForm}
          required
          loading={project.isCoverLoading}
          errors={errorsMessageUploaderImageSingle}
          minWidth={minWidth}
          minHeight={minHeight}
          {...{ "data-label": "project-cover-uploader" }}
        />
      )}
    </Form.Field>
  );
};

Cover.propTypes = {
  project: PropTypes.object,
  label: PropTypes.string,
  maxUploadSizeMessage: PropTypes.string,
  descriptionMessage: PropTypes.string,
  progressMessage: PropTypes.string,
  maxNumFiles: PropTypes.number,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  isMobile: PropTypes.bool,
  validateForm: PropTypes.func,
  onRemove: PropTypes.func,
  onCoverStartLoading: PropTypes.func,
  onCoverStopLoading: PropTypes.func,
  onSaveProject: PropTypes.func,
  onFocusElement: PropTypes.func,
  afterRemoveElement: PropTypes.func,
  reCaptchaVersion: PropTypes.string,
};

Cover.defaultProps = {
  project: {},
  label: "",
  maxUploadSizeMessage: "",
  descriptionMessage: "",
  progressMessage: "",
  maxNumFiles: 1,
  minWidth: 1200,
  minHeight: 1200,
  isMobile: false,
  validateForm: () => {},
  onRemove: () => {},
  onCoverStartLoading: () => {},
  onCoverStopLoading: () => {},
  onSaveProject: () => {},
  onFocusElement: () => {},
  afterRemoveElement: () => {},
  reCaptchaVersion: RECAPTCHA_VERSION.V3,
};

export default Cover;
